var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgZoomIn = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 62.5 64",
    ref: ref,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.25,56.5A28.25,28.25,0,1,1,56.5,28.25,28.28,28.28,0,0,1,28.25,56.5Zm0-48.28a20,20,0,1,0,20,20A20,20,0,0,0,28.25,8.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M61.18,56.31l-9.69-9.69a28.34,28.34,0,0,1-6.6,6.14l9.93,9.92a4.5,4.5,0,1,0,6.36-6.37Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.61,
    y: 17.01,
    width: 7.28,
    height: 22.48,
    transform: "translate(0 56.5) rotate(-90)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.61,
    y: 17.01,
    width: 7.28,
    height: 22.48
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgZoomIn);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA2Mi41IDY0Ij48ZGVmcz48c3R5bGU+LmNscy0xe2ZpbGw6I2ZmZjt9PC9zdHlsZT48L2RlZnM+PHRpdGxlPkFzc2V0IDI8L3RpdGxlPjxnIGlkPSJMYXllcl8yIiBkYXRhLW5hbWU9IkxheWVyIDIiPjxnIGlkPSJMYXllcl8xLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMSI+PHBhdGggY2xhc3M9ImNscy0xIiBkPSJNMjguMjUsNTYuNUEyOC4yNSwyOC4yNSwwLDEsMSw1Ni41LDI4LjI1LDI4LjI4LDI4LjI4LDAsMCwxLDI4LjI1LDU2LjVabTAtNDguMjhhMjAsMjAsMCwxLDAsMjAsMjBBMjAsMjAsMCwwLDAsMjguMjUsOC4yMloiLz48cGF0aCBjbGFzcz0iY2xzLTEiIGQ9Ik02MS4xOCw1Ni4zMWwtOS42OS05LjY5YTI4LjM0LDI4LjM0LDAsMCwxLTYuNiw2LjE0bDkuOTMsOS45MmE0LjUsNC41LDAsMSwwLDYuMzYtNi4zN1oiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjI0LjYxIiB5PSIxNy4wMSIgd2lkdGg9IjcuMjgiIGhlaWdodD0iMjIuNDgiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDAgNTYuNSkgcm90YXRlKC05MCkiLz48cmVjdCBjbGFzcz0iY2xzLTEiIHg9IjI0LjYxIiB5PSIxNy4wMSIgd2lkdGg9IjcuMjgiIGhlaWdodD0iMjIuNDgiLz48L2c+PC9nPjwvc3ZnPg==";